module.exports = __webpack_public_path__ + "static/media/video_2.abf9bf94.mp4";